module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('HeaderBar'), _vm._v(" "), _c('HeaderTabs', {
    staticClass: "tabs"
  }), _vm._v(" "), _c('FooterNav')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21d3603e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index.vue
// module id = 138
// module chunks = 1